import { Arrow } from './Arrow';

export function CaseStudies() {
  const cases = [
    {
      n: "01",
      tag: "AI · Web app",
      title: "Viro AI Editor",
      lede: "AI-powered video editor. Studio-grade tools, browser-light feel.",
      year: "2025",
      tags: ["Product design", "AI tooling", "Web app"],
      img: "/assets/cases/viro.png",
      url: "https://www.behance.net/gallery/224669979/Viro-AI-Editor",
      results: ["+38% editing speed", "12k creators onboarded", "4.8★ user rating"],
    },
    {
      n: "02",
      tag: "AI · iOS",
      title: "FACE26",
      lede: "AI mobile photo editor. Retouch, restore, reimagine.",
      year: "2024",
      tags: ["iOS", "AI", "Photo editor"],
      img: "/assets/cases/face26.png",
      url: "https://www.behance.net/gallery/178998883/FACE26-AI-Mobile-app-editor",
      results: ["12M+ downloads", "+42% retention lift", "Featured by App Store"],
    },
    {
      n: "03",
      tag: "AI · Wellness",
      title: "Zen AI",
      lede: "Personalised mindfulness and breathing app.",
      year: "2025",
      tags: ["Wellness", "Mobile", "AI"],
      img: "/assets/cases/zen.png",
      url: "https://www.behance.net/gallery/210720293/Zen-AI-Personalized-Mindfulness-Breathing-App",
      results: ["+56% session length", "85k daily actives", "Reduced churn by 27%"],
    },
    {
      n: "04",
      tag: "EdTech · Web",
      title: "Artbox",
      lede: "Educational platform redesign. Calmer, clearer, faster.",
      year: "2024",
      tags: ["EdTech", "Web", "Redesign"],
      img: "/assets/cases/artbox.png",
      url: "https://www.behance.net/gallery/175518367/Artbox-Educational-Platform-Website-Redesign",
      results: ["+34% course completion", "48k students enrolled", "Cut signup time by 60%"],
    },
    {
      n: "05",
      tag: "Fintech · iOS",
      title: "Crypt.",
      lede: "Cryptocurrency mobile application. Quiet by default.",
      year: "2023",
      tags: ["Fintech", "iOS", "Crypto"],
      img: "/assets/cases/crypt.png",
      url: "https://www.behance.net/gallery/140952525/Crypt-Cryptocurrency-Mobile-Application",
      results: ["$240M assets tracked", "+62% trade volume", "1.2s avg. transaction"],
    },
    {
      n: "06",
      tag: "Fintech · Web + iOS",
      title: "AssetDash",
      lede: "Portfolio tracker for serious holders.",
      year: "2023",
      tags: ["Fintech", "Web", "iOS"],
      img: "/assets/cases/assetdash.png",
      url: "https://www.behance.net/gallery/161274349/AssetDash-Portfolio-Tracker-mobile-and-web-app",
      results: ["120k portfolios tracked", "+28% paid conversion", "Featured by Coinbase"],
    },
  ];
  
  return (
    <section className="cases dark" id="case-studies">
      <div className="container">
        <div className="cases-head">
          <span className="eyebrow" data-reveal><span className="dot"></span>Selected work · 2023, 2025</span>
          <div className="cases-head-row">
            <h2 className="display cases-title" data-reveal style={{ "--reveal-delay": "80ms" }}>
              Six things I'm<br />proud of, lately.
            </h2>
            <p className="cases-lede" data-reveal style={{ "--reveal-delay": "160ms" }}>
              Each card rises over the last as you scroll. Click any one to read the long version on Behance.
            </p>
          </div>
        </div>
      </div>

      <div className="cases-stack">
        {cases.map((c, i) => (
          <a
            key={c.title}
            href={c.url}
            target="_blank"
            rel="noopener noreferrer"
            className="case-stack-item"
            data-cursor="hover"
            style={{ "--i": i, top: `calc(80px + ${i * 24}px)` }}
          >
            <div className="container case-stack-inner">
              <div className="case-stack-head">
                <span className="case-stack-num">{c.n}</span>
                <div className="case-stack-tags">
                  {c.tags.map(t => <span key={t}>{t}</span>)}
                </div>
                <span className="case-stack-year">{c.year}</span>
              </div>
              <div className="case-stack-body">
                <div className="case-stack-text">
                  <h3 className="display case-stack-title">{c.title}</h3>
                  <p className="case-stack-lede">{c.lede}</p>
                  <div className="case-stack-results">
                    <span className="case-stack-results-label">Results</span>
                    <ul>
                      {c.results.map((r, j) => <li key={j}>{r}</li>)}
                    </ul>
                  </div>
                  <span className="case-stack-cta">Explore <Arrow size={16} /></span>
                </div>
                <div className="case-stack-art">
                  <img src={c.img} alt={c.title} loading="lazy" />
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>

      <div className="container">
        <div className="cases-foot">
          <a href="https://www.behance.net/DianaHakobyan1" target="_blank" rel="noopener noreferrer" className="btn btn-primary">See all on Behance <Arrow /></a>
        </div>
      </div>
    </section>
  );
}
